import { z } from 'zod';

import {
  CursorPaginationMetaSchema,
  ListSortOrderSchema,
  PaginationSchema,
} from '../../../pagination.js';

export const MaintenanceChecklistListSortFieldSchema = z.enum(['name', 'itemCount']);
export type MaintenanceChecklistListSortField = z.infer<
  typeof MaintenanceChecklistListSortFieldSchema
>;

export const ListMaintenanceChecklistsQuerySchema = PaginationSchema.extend({
  q: z.preprocess(
    (val) => (typeof val === 'string' && val.trim() === '' ? undefined : val),
    z.string().trim().min(2).max(100).optional(),
  ),
  sort: MaintenanceChecklistListSortFieldSchema.optional(),
  order: ListSortOrderSchema.optional(),
});

export const MaintenanceChecklistListItemSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  categoryCount: z.number().int().nonnegative(),
  itemCount: z.number().int().nonnegative(),
  updatedAt: z.iso.datetime(),
});

export const ListMaintenanceChecklistsResponseSchema = z.object({
  items: z.array(MaintenanceChecklistListItemSchema),
  pagination: CursorPaginationMetaSchema,
});

export type ListMaintenanceChecklistsQuery = z.infer<typeof ListMaintenanceChecklistsQuerySchema>;
export type MaintenanceChecklistListItem = z.infer<typeof MaintenanceChecklistListItemSchema>;
export type ListMaintenanceChecklistsResponse = z.infer<
  typeof ListMaintenanceChecklistsResponseSchema
>;
